export const BUBBLE_BUTTON_SIZE = 48;
